import { FC } from 'react';

export const FillifyLogo: FC = () => {
  return (
    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.00195312 9.74609V25.9938C0.00195312 27.1016 0.899634 28.0003 2.00842 28.0003H24.2816C25.3894 28.0003 26.288 27.1026 26.288 25.9938V9.74609H0.00195312Z"
        fill="white"
      />
      <path
        d="M8.15645 17.5344H3.52832C3.46197 17.5344 3.40869 17.4811 3.40869 17.4147V12.7866C3.40869 12.7203 3.46197 12.667 3.52832 12.667H8.15645C8.2228 12.667 8.27608 12.7203 8.27608 12.7866V17.4147C8.27708 17.4811 8.2228 17.5344 8.15645 17.5344Z"
        fill="#1239BA"
      />
      <path
        d="M15.4587 17.5344H10.8306C10.7642 17.5344 10.7109 17.4811 10.7109 17.4147V12.7866C10.7109 12.7203 10.7642 12.667 10.8306 12.667H15.4587C15.525 12.667 15.5783 12.7203 15.5783 12.7866V17.4147C15.5783 17.4811 15.525 17.5344 15.4587 17.5344Z"
        fill="#1239BA"
      />
      <path
        d="M22.76 17.5344H18.1318C18.0655 17.5344 18.0122 17.4811 18.0122 17.4147V12.7866C18.0122 12.7203 18.0655 12.667 18.1318 12.667H22.76C22.8263 12.667 22.8796 12.7203 22.8796 12.7866V17.4147C22.8796 17.4811 22.8263 17.5344 22.76 17.5344Z"
        fill="#1239BA"
      />
      <path
        d="M8.15645 24.1057H3.52832C3.46197 24.1057 3.40869 24.0524 3.40869 23.986V19.3579C3.40869 19.2916 3.46197 19.2383 3.52832 19.2383H8.15645C8.2228 19.2383 8.27608 19.2916 8.27608 19.3579V23.986C8.27708 24.0524 8.2228 24.1057 8.15645 24.1057Z"
        fill="#1239BA"
      />
      <path
        d="M15.4587 24.1057H10.8306C10.7642 24.1057 10.7109 24.0524 10.7109 23.986V19.3579C10.7109 19.2916 10.7642 19.2383 10.8306 19.2383H15.4587C15.525 19.2383 15.5783 19.2916 15.5783 19.3579V23.986C15.5783 24.0524 15.525 24.1057 15.4587 24.1057Z"
        fill="#1239BA"
      />
      <path
        d="M22.76 24.1057H18.1318C18.0655 24.1057 18.0122 24.0524 18.0122 23.986V19.3579C18.0122 19.2916 18.0655 19.2383 18.1318 19.2383H22.76C22.8263 19.2383 22.8796 19.2916 22.8796 19.3579V23.986C22.8796 24.0524 22.8263 24.1057 22.76 24.1057Z"
        fill="#1239BA"
      />
      <path
        d="M11.6841 15.1007L12.8723 17.2117L15.5784 12.667L12.8723 15.9722L11.6841 15.1007Z"
        fill="#E8EDFD"
      />
      <path
        d="M18.5388 21.9557L19.727 24.0657L22.4331 19.522L19.727 22.8272L18.5388 21.9557Z"
        fill="#E8EDFD"
      />
      <path
        d="M24.2806 1.71494H18.3577V1.12587C18.3577 0.503627 17.8541 0 17.2319 0C16.6096 0 16.106 0.503627 16.106 1.12587V1.71494H10.1811V1.12587C10.1811 0.503627 9.67747 0 9.05523 0C8.43298 0 7.92936 0.503627 7.92936 1.12587V1.71494H2.00647C0.898689 1.71494 0 2.61263 0 3.72141V7.5564H26.2851V3.72141C26.2871 2.61263 25.3884 1.71494 24.2806 1.71494ZM9.05624 5.33783C8.66821 5.33783 8.35357 5.02319 8.35357 4.63517C8.35357 4.24715 8.66821 3.93251 9.05624 3.93251C9.44426 3.93251 9.7589 4.24715 9.7589 4.63517C9.7589 5.02319 9.44426 5.33783 9.05624 5.33783ZM13.1446 5.33783C12.7565 5.33783 12.4419 5.02319 12.4419 4.63517C12.4419 4.24715 12.7565 3.93251 13.1446 3.93251C13.5326 3.93251 13.8472 4.24715 13.8472 4.63517C13.8472 5.02319 13.5326 5.33783 13.1446 5.33783ZM17.2329 5.33783C16.8449 5.33783 16.5302 5.02319 16.5302 4.63517C16.5302 4.24715 16.8449 3.93251 17.2329 3.93251C17.6209 3.93251 17.9355 4.24715 17.9355 4.63517C17.9355 5.02319 17.6209 5.33783 17.2329 5.33783Z"
        fill="#E8EDFD"
      />
    </svg>
  );
};
